
import PlayAdd from "../../../assets/duotone/PlayAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PlayAddIcon({ className, dataTestid = "PlayAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PlayAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
